import { ActivityState } from '@/lib/enums';

export default function getActivityStateCondition(activityState) {
  return {
    entity: 'activities',
    identifier: 'disabled_at',
    metricProperty: null,
    relative: 'EXISTS',
    value: activityState === ActivityState.INACTIVE,
  };
}
